import { html } from "lit";

export function TeaserProductSmallTemplate(args) {
    return html`
        <ux-iws-link-wrapper class="ux-iws-teaser-product-small">
            <div class="ux-iws-teaser-product-small__text-wrapper">
                <div
                    class="ux-text-title ux-text-title--bold ux-text-title--green-square"
                >
                    ${args.title}
                </div>
                <p
                    class="ux-iws-teaser-product-small__text ux-text-normal ux-text-normal--light-gray"
                >
                    ${args.description}
                </p>
                <ux-collapsible
                    button-text-collapsed="${args.openText}"
                    button-text-expanded="${args.closeText}"
                    is-expanded="false"
                    direction="bottom"
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    nonne merninisti licere mihi ista probare, quae sunt a te.
                </ux-collapsible>
            </div>
            <div class="ux-iws-teaser-product-small__button-wrapper">
                <a href="${args.linkUrl}" class="ux-button">${args.linkText}</a>
            </div>
        </ux-iws-link-wrapper>
    `;
}
